import {UI} from "../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../stem-core/src/ui/Style";

import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../stem-core/src/decorators/Style";
import {isSmallScreen} from "../../Utils";
import {Device} from "../../../stem-core/src/base/Device";
import {DEFAULT_TRANSITION_TIME_MS} from "../../../blink-sdk/Constants";


class WidgetScrimStyle extends StyleSheet {
    transitionTime = DEFAULT_TRANSITION_TIME_MS;

    @styleRule
    container = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 3,
        borderRadius: () => isSmallScreen() && !Device.isLandscape() ? 0 : 12,
        background: this.themeProps.MERCHANT_SCRIM_BACKGROUND,
        opacity: 0,
        transition: this.transitionTime / 1000 + "s ease",
    };

    @styleRule
    visible = {
        opacity: 1,
    };
}

@registerStyle(WidgetScrimStyle)
export class WidgetScrim extends UI.Element {
    hide(timeout) {
        this.removeClass(this.styleSheet.visible);
        this.attachTimeout(() => this.destroyNode(), timeout);
    }

    onMount() {
        super.onMount();
        this.attachTimeout(() => this.addClass(this.styleSheet.visible));
    }
}
